import { useEffect, useState } from "react"
import { FaEllipsis, FaPlus } from "react-icons/fa6"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import api from "../config/backend"
import { SpinnerCircular } from "spinners-react"
import { toast } from "react-toastify"
import { IoPersonSharp } from "react-icons/io5"
import "./css/ExpensesList.css"
import { Document, Page, pdfjs } from 'react-pdf'

const ExpensesList = ({ expensesList, setExpensesList, setCreateExpense }) => {
    const [activeExpense, setActiveExpense] = useState(0)
    const [numPages, setNumPages] = useState()
    const [pageNumber, setPageNumber] = useState(1)

    const navigate = useNavigate()

    const token = localStorage.getItem("_crm__token")

    const handleRemoveReceipt = async (expensehash) => {
        const { data, status } = await axios.post(`${api}/Accounting/remove-receipt`, { token, expensehash })

        if (data.success) {
            toast.info(data.message)
            setExpensesList(prev => {
                const copy = JSON.parse(JSON.stringify(prev))

                const updated = copy.map(item => {
                    if (item.hash === expensehash) {
                        return { ...item, receipt: undefined }
                    }

                    return item
                })

                return updated
            })
        }
    }

    function currencyFormat(number) {
        return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    const downloadReceipt = async (imageLink, filename) => {
        const response = await axios.get(imageLink, { responseType: "blob" })

        const reader = new FileReader()

        reader.readAsDataURL(response.data)

        reader.onload = () => {
            const link = document.createElement('a')
            link.href = reader.result
            link.setAttribute('download', filename ? filename : "Receipt.png")
            document.body.appendChild(link)
            link.click()
        }
    }

    const expenseDetails = expensesList ? expensesList[activeExpense] : undefined

    const onDocumentLoadSuccess = (numPages) => {
        setNumPages(numPages._pdfInfo.numPages)
    }

    useEffect(() => { 
        pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
    }, [])

    return (
        <div className="_7fzc _4zoj">
            <div className="sidebar app-new-quotes-sidebar">
                <div className="header">
                    <div className="all-qutoes">
                        <h3>All Expenses</h3>
                    </div>
                    <div className="hatchet-scab">
                        <button onClick={() => setCreateExpense(true)}><FaPlus /> New</button>
                    </div>
                </div>
                <div className="reacting-eggs">
                    {expensesList.map((expense, index) => {
                        return (
                            <div
                                key={index}
                                className={activeExpense === index ? "stubby-hex active" : "stubby-hex"}
                                onClick={() => setActiveExpense(index)}
                            >
                                <div className="spinner-them">
                                    <div>{expense.expenseaccount.title}</div>
                                    <div>₹{expense.amount}</div>
                                </div>
                                <div style={{ display: "flex", gap: "4px", fontSize: "12px" }}>
                                    <div>{new Date(expense.expensedate).toDateString()}</div>
                                    {expense.vendor ? <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                        <div>
                                            | <IoPersonSharp />
                                        </div>
                                        <span>{expense.vendor.firstname} {expense.vendor.lastname}</span>
                                    </div> : undefined}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="squiffed-dint">
                {/* <div className="header">
                    Expense Details
                </div> */}
                <div className="settings">
                    <div onClick={() => navigate("/accounting/expenses/edit/" + expensesList[activeExpense].hash)}>Edit</div>
                </div>
                <div className="drape-cop">
                    {expenseDetails ? (
                        <div className="riblike-gear main_riblike-gear">
                            <div>Expense Amount</div>
                            <div className="gabbro-lux">
                                <span>₹{currencyFormat(expenseDetails.amount)}</span>
                                <div className="feezed-ante">
                                    on {new Date(expenseDetails.expensedate).toDateString()}
                                </div>
                            </div>
                            <div className="berry-mold">
                                <div className="dongolas-fir">
                                    {expenseDetails.expenseaccount.title}
                                </div>
                                <div>
                                    {expenseDetails.expenseaccount.category}
                                </div>
                            </div>
                            <div className="lightful-icer">
                                <div className="flounder-swim">
                                    {expenseDetails.paidthrough ? (
                                        <div className="bedye-huts">
                                            <div>Paid Through</div>
                                            <div className="tiple-paws">{expenseDetails.paidthrough}</div>
                                        </div>
                                    ) : undefined}
                                    {expenseDetails.invoice ? (
                                        <div className="bedye-huts">
                                            <div>Ref #</div>
                                            <div className="tiple-paws">{expenseDetails.invoice}</div>
                                        </div>
                                    ) : undefined}
                                    {expenseDetails.customer ? (
                                        <div className="bedye-huts">
                                            <div>Customer</div>
                                            <div className="tiple-paws">{expenseDetails.customer.firstname} {expenseDetails.customer.lastname}</div>
                                            <div className="supposer-odd">{expenseDetails.customer.email}</div>
                                        </div>
                                    ) : undefined}
                                    {expenseDetails.vendor ? (
                                        <div className="bedye-huts">
                                            <div>Paid To</div>
                                            <div className="tiple-paws">{expenseDetails.vendor.firstname} {expenseDetails.vendor.lastname}</div>
                                            <div className="supposer-odd">{expenseDetails.vendor.email}</div>
                                        </div>
                                    ) : undefined}
                                    <div style={{ marginTop: "20px" }}>
                                        {expenseDetails.note ? expenseDetails.note : undefined}
                                    </div>
                                </div>
                                <div className="hawker-nix">
                                    {expenseDetails.receipt ? (
                                        <div>
                                            <div style={{ marginBottom: "20px" }}>Receipt</div>
                                            {expenseDetails.receipt.endsWith(".pdf") ? (
                                                <div className="pathoses-mask">
                                                    <Document file={api.replace("/api", "/public") + "/" + expenseDetails.receipt} onLoadSuccess={onDocumentLoadSuccess}>
                                                        <Page width={240} pageNumber={pageNumber} />
                                                    </Document>
                                                    <p>
                                                        Page {pageNumber} of {numPages}
                                                    </p>
                                                </div>
                                            ) : <img src={`${api.replace("/api", "/public")}/${expenseDetails.receipt}`} />}
                                            <div style={{ marginTop: "20px", display: "flex", alignItems: "center", gap: "10px" }}>
                                                <div style={{ backgroundColor: "#2068F3", color: "white", textDecoration: "none", padding: "6px 10px", borderRadius: "4px", cursor: "pointer" }} onClick={() => downloadReceipt(`${api.replace("/api", "/public")}/${expenseDetails.receipt}`, expenseDetails.receipt)}>Download</div>
                                                <div style={{ backgroundColor: "rgb(220, 91, 91)", color: "white", textDecoration: "none", padding: "6px 10px", borderRadius: "4px", cursor: "pointer" }} onClick={() => handleRemoveReceipt(expenseDetails.hash)}>Remove</div>
                                            </div>
                                        </div>
                                    ) : undefined}
                                </div>
                            </div>
                        </div>
                    ) : undefined}
                </div>
            </div>
        </div>
    )
}

export default ExpensesList
